(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // HB — the "Most reviewed" entry in the sort dropdown is a template view
  // (?view=most-reviewed), not a sort_by value — Shopify has none for review
  // count. The desktop row is a link and needs no help; the mobile <select> can
  // only hold an <option>, whose value means nothing to Shopify, so navigate to
  // the view instead of letting facets.js submit it as a sort.
  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement) || target.name !== 'sort_by') return;
      if (target.value !== 'most-reviewed') return;

      const href = target.selectedOptions[0]?.dataset.hbMostReviewedUrl;
      if (!href) return;

      // Stop facets.js from also submitting sort_by=most-reviewed.
      event.stopPropagation();
      window.location.assign(href);
    },
    true
  );

  // The dropdown's keyboard handler activates a row by clicking the radio inside
  // it; the "Most reviewed" row is a link and has none, so Enter/Space would be
  // swallowed. Let the link handle them instead.
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const link = event.target instanceof Element ? event.target.closest('.sorting-filter__option--link') : null;
      if (!(link instanceof HTMLAnchorElement)) return;

      event.stopPropagation();

      // Enter activates a focused link on its own, Space does not.
      if (event.key === ' ') {
        event.preventDefault();
        link.click();
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hb-subscription-plans"] && !Shopify.designMode) return;
  try {
    /**
   * Drives the product form from the purchase-option panel.
   *
   * The panel sits beside the buy-buttons form rather than inside it, so it
   * cannot submit inputs by position. It writes a hidden selling_plan field
   * into that form and sets the form's quantity, which is what both Add to cart
   * and Shop Pay read.
   */
  class HbSubscriptionPlans extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      this.addEventListener('change', () => this.sync());
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-hb-sp-tab]');
        if (tab) this.setMode(tab.dataset.hbSpTab);
      });

      // A variant change morphs only the variant picker, so this block survives
      // it untouched and has to be told which set to show.
      this._onVariantUpdate = (event) => {
        const detail = event.detail || {};
        const productId = detail.data && detail.data.productId;
        if (productId && this.dataset.productId && String(productId) !== String(this.dataset.productId)) return;
        const id = detail.resource && detail.resource.id;
        if (id) this.showVariant(String(id));
      };
      document.addEventListener('variant:update', this._onVariantUpdate);

      // Recharge injects its own selling_plan <select> into the product form,
      // preset to the monthly plan, and hiding the widget does not stop it
      // submitting. Left alone it turns a one-time purchase into a monthly
      // subscription. The form data is rewritten as it is built instead, which
      // covers every path that serialises the form (product-form.js, Shop Pay)
      // however the widget re-renders.
      this._onFormData = (event) => {
        const radio = this.checkedRadio();
        if (!radio) return;
        const data = event.formData;
        for (const key of Array.from(data.keys())) {
          if (key === 'selling_plan' || key.startsWith('selling_plan_')) data.delete(key);
        }
        if (radio.value) data.set('selling_plan', radio.value);
      };
      this._form = this.form;
      if (this._form) this._form.addEventListener('formdata', this._onFormData);

      this.retireLegacyNote();
      this.retireRechargeWidget();
      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this._onVariantUpdate);
      if (this._form) this._form.removeEventListener('formdata', this._onFormData);
      if (this._rechargeObserver) this._rechargeObserver.disconnect();
    }

    get form() {
      const byId = this.dataset.formId && document.getElementById(this.dataset.formId);
      if (byId) return byId;
      const scope = this.closest('.product-details') || this.parentElement || document;
      return (
        scope.querySelector('product-form-component form') || document.querySelector('form[action*="/cart/add"]')
      );
    }

    activeSet() {
      return this.querySelector('.hb-sp__set:not([hidden])');
    }

    planRadios() {
      const set = this.activeSet();
      return set ? Array.from(set.querySelectorAll('.hb-sp__radio')) : [];
    }

    oneTimeRadio() {
      const row = this.querySelector('.hb-sp__onetime:not([hidden])');
      return row ? row.querySelector('.hb-sp__radio') : null;
    }

    checkedRadio() {
      const oneTime = this.oneTimeRadio();
      const radios = this.planRadios();
      if (oneTime) radios.push(oneTime);
      return radios.find((radio) => radio.checked) || null;
    }

    /** Shows one variant's cards and one-time row, and hides everyone else's. */
    showVariant(variantId) {
      if (!variantId) return;
      const parts = Array.from(this.querySelectorAll('[data-hb-sp-variant]'));
      if (!parts.some((part) => part.dataset.hbSpVariant === String(variantId))) return;

      parts.forEach((part) => {
        const mine = part.dataset.hbSpVariant === String(variantId);
        part.hidden = !mine;
        // Disabled rather than merely hidden: a hidden radio that is still
        // checked would keep answering for a variant nobody is looking at.
        part.querySelectorAll('input').forEach((input) => {
          input.disabled = !mine;
        });
      });

      this.sync();
    }

    mode() {
      const checked = this.checkedRadio();
      if (checked) return checked.value ? 'subscribe' : 'onetime';
      return this.dataset.defaultMode === 'onetime' ? 'onetime' : 'subscribe';
    }

    /** Moves the selection between the term cards and the one-time row. */
    setMode(mode) {
      const set = this.activeSet();
      const hasPlans = set ? Number(set.dataset.hbSpSubs || 0) > 0 : false;

      if (mode === 'onetime' || !hasPlans) {
        const oneTime = this.oneTimeRadio();
        if (oneTime) oneTime.checked = true;
      } else {
        const radios = this.planRadios();
        const remembered = radios.indexOf(this._lastPlanRadio) !== -1 ? this._lastPlanRadio : null;
        const pick = radios.find((radio) => radio.checked) || remembered || radios[0];
        if (pick) pick.checked = true;
      }

      this.sync();
    }

    /** Mirrors the current choice into the product form and the panel's own chrome. */
    sync() {
      const radio = this.checkedRadio();
      if (!radio) return;
      if (radio.value) this._lastPlanRadio = radio;

      const form = this.form;
      if (form) {
        this.applySellingPlan(form, radio.value);
        this.applyQuantity(form, Number(radio.dataset.hbSpQty || 1) || 1, Boolean(radio.value));
      }
      this.render(radio);
    }

    applySellingPlan(form, planId) {
      let input = form.querySelector('input[name="selling_plan"][data-hb-sp]');
      if (!planId) {
        // Removed rather than emptied: an empty selling_plan is still submitted,
        // where an absent one is what a one-time purchase looks like.
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-hb-sp', '');
        form.appendChild(input);
      }
      input.value = planId;
    }

    applyQuantity(form, quantity, isSubscription) {
      const owns = this.dataset.ownQuantity === 'true';
      const details = this.closest('.product-details');
      if (details && owns) details.classList.toggle('hb-sp-owns-quantity', isSubscription);

      let input = form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.setAttribute('data-hb-sp', '');
        form.appendChild(input);
      }
      // Written on every change, including back down to 1 for a one-time
      // purchase: the stepper reappears then, and it would otherwise reappear
      // holding the last term's count.
      input.value = String(quantity);
    }

    /** Paints tabs, card visibility and the combined-value line from one choice. */
    render(radio) {
      const set = this.activeSet();
      const hasPlans = set ? Number(set.dataset.hbSpSubs || 0) > 0 : false;
      const mode = radio.value ? 'subscribe' : 'onetime';

      const tabs = this.querySelector('[data-hb-sp-tabs]');
      if (tabs) {
        tabs.hidden = !hasPlans;
        tabs.querySelectorAll('[data-hb-sp-tab]').forEach((tab) => {
          tab.setAttribute('aria-pressed', String(tab.dataset.hbSpTab === mode));
        });
      }

      const cards = set && set.querySelector('.hb-sp__cards');
      if (cards) cards.hidden = mode === 'onetime';

      const britemind = this.querySelector('[data-hb-sp-bm]');
      if (britemind) {
        britemind.hidden = mode === 'onetime' || !set || set.dataset.hbSpBritemind !== 'true';
      }

      const value = this.querySelector('[data-hb-sp-total-value]');
      if (value) {
        value.textContent = radio.dataset.hbSpValue || '';
        const line = value.closest('.hb-sp__bm-total');
        if (line) line.hidden = !radio.dataset.hbSpValue;
      }
    }

    /**
     * The BriteMind line under the buy buttons exists only to be moved into the
     * Recharge widget. This panel makes the same claim in its own right, so the
     * orphaned line is retired rather than left to attach itself to a radio here.
     */
    retireLegacyNote() {
      const scope = this.closest('.product-details') || document;
      scope.querySelectorAll('.buy-buttons-britemind').forEach((note) => note.remove());
    }

    /**
     * Hides the Recharge selector, which this panel replaces.
     *
     * Recharge injects it client-side even with its app block removed from the
     * template, so there is no Liquid seam to suppress it from. The app embeds
     * are left enabled on purpose: the same Storefront Experiences embed serves
     * the Recharge cart drawer and the bundles widget on the bundle product, so
     * switching it off store-wide would take those with it.
     *
     * Found by the `rc-` prefix inside the product column rather than by an
     * exact class, because Recharge ships its own names and changes them
     * between versions. The prefix is the store's own observed shape, see the
     * widget rules in snippets/hb-product-cta.liquid. The theme's `rc-bundle-*`
     * markup is skipped, though it only ever renders in the cart.
     *
     * Hidden rather than removed: the widget belongs to an app that owns that
     * subtree, and pulling it out from under the app invites it to throw or
     * remount in a loop.
     */
    retireRechargeWidget() {
      const scope = this.closest('.product-details');
      if (!scope) return;

      const theirs = (el) => {
        if (el.closest('hb-subscription-plans')) return false;
        if (/recharge/i.test(el.id)) return true;
        return Array.from(el.classList).some(
          (name) => (name.startsWith('rc-') && !name.startsWith('rc-bundle-')) || /recharge/i.test(name)
        );
      };

      const sweep = () => {
        scope.querySelectorAll('[class],[id]').forEach((el) => {
          // Document order, so the outermost match is classed first and its
          // descendants then see a retired ancestor and are left alone.
          if (theirs(el) && !el.closest('.hb-sp-retired')) el.classList.add('hb-sp-retired');
        });
      };

      sweep();
      // childList only: the class this writes is an attribute change, so the
      // observer cannot retrigger itself on its own work.
      this._rechargeObserver = new MutationObserver(sweep);
      this._rechargeObserver.observe(scope, { childList: true, subtree: true });
    }
  }

  if (!customElements.get('hb-subscription-plans')) {
    customElements.define('hb-subscription-plans', HbSubscriptionPlans);
  }
  } catch(e) { console.error(e); }
})();

})();
